import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface FinCstInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function FinCstInternalControls({ onBack, setActiveSection, controlsListSection }: FinCstInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Finance Cost"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}



